import { Ng2StateDeclaration } from '@uirouter/angular';
import * as fromEmailAudit from './';

export const EmailAuditRoute: Ng2StateDeclaration = {
    // name: 'emailaudit.**'
    name: 'emailaudit',
    url: '/emailaudit',
    // , loadChildren: () => import('./manage-users.module').then(r => r.ManageUsersModule)
    data: { requiresAuth: true },
    params: { process: {} },
    component: fromEmailAudit.EmailAuditContainerComponent
};
